<template>
  <div
    class="obituary-single__hero-background"
    :class="{ 'not-imgix': !isImgix }"
  >
    <img
      v-if="!isImgix && heroImageFallback"
      :alt="heroImageFallback.alt"
      :src="heroImageFallback.src"
      :srcset="heroImageFallback.srcset"
    >
    <picture v-else>
      <source
        v-for="source in heroImageSources"
        :key="source.srcset"
        :media="source.media"
        :srcset="source.srcset"
        :type="source.type"
      >
      <img
        v-if="heroImageFallback"
        :alt="heroImageFallback.alt"
        :src="heroImageFallback.src"
        :srcset="heroImageFallback.srcset"
      >
    </picture>
    <SlideshowBanner v-if="!isEditMode" />
    <div class="obituary-single__hero-background-edit" v-if="isEditMode">
      <Loader :loading="isUploadingHeroImage" />
      <button
        class="btn btn-white btn-sm"
        type="button"
        v-if="!isUploadingHeroImage"
        @click.prevent="toggleModal"
      >
        {{
          heroImageSources || heroImageFallback
            ? texts.changeBackground
            : texts.addBackground
        }}
      </button>
      <input
        accept="image/*"
        style="display: none"
        type="file"
        ref="file"
        @change="onFileChange"
      >
    </div>
    <modal
      v-if="isEditMode"
      :disabled="false"
      :modal-heading="texts.imageModalHeading"
      :modal-open="isHeroModalOpen"
      :toggle-modal="toggleModal"
    >
      <div>
        <div class="hero-images-grid">
          <div>
            <div class="hero-images-grid__image hero-images-grid__upload-image">
              <button
                class="btn invisible"
                type="button"
                v-if="!isUploadingHeroImage"
                @click.prevent="openFilePicker"
              >
                {{ texts.uploadImage }}
              </button>
            </div>
            <input
              accept="image/*"
              style="display: none"
              type="file"
              ref="file"
              @change="onFileChange"
            >
          </div>
          <div v-for="image in defaultHeroImages" :key="image.id">
            <div class="hero-images-grid__image">
              <button
                class="hero-images-grid__pick"
                type="button"
                @click.prevent="uploadDefaultImage(image)"
              >
                <img :alt="image.title" :src="image.sizes.archive">
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import Loader from "Components/loader/Loader.vue";
  import Modal from "Components/Modal.vue";
  import { mapActions, mapMutations, mapState } from "vuex";
  import SlideshowBanner from "./Slideshow/SlideshowBanner.vue";

  const LEADING_SLASH = /^\//;

  export default {
    beforeMount() {
      const sources = this.$mountElSnapshot.querySelectorAll("source");
      const image = this.$mountElSnapshot.querySelector("img");

      if (sources) {
        this.setState({ heroImageSources: sources });
      }

      if (image) {
        this.setState({ heroImageFallback: image });
      }
    },
    components: {
      Loader,
      Modal,
      SlideshowBanner,
    },
    computed: {
      ...mapState("creator", [
        "isEditMode",
        "isUploadingHeroImage",
        "heroImageSources",
        "heroImageFallback",
        "isHeroModalOpen",
        "defaultHeroImages",
      ]),
    },
    data() {
      const { isImgix } = this.$mountEl.dataset;

      return {
        isImgix,
        texts: lavendlaObituary.creator,
      };
    },
    methods: {
      ...mapActions("creator", [
        "uploadImage",
        "loadDefaultHeroImages",
        "setDefaultBackgroundImage",
      ]),
      ...mapMutations("creator", ["setState"]),
      /**
       * Extract the S3 storage path from an Imgix URL.
       * Falls back to passing the full URL if extraction fails.
       */
      extractStoragePath(url) {
        if (!url) {
          return null;
        }

        try {
          const parsedUrl = new URL(url);
          // Remove leading slash from path
          return parsedUrl.pathname.replace(LEADING_SLASH, "");
        } catch {
          // If URL parsing fails, return the original value
          return url;
        }
      },
      onFileChange(e) {
        const [file] = e.target.files;
        this.uploadImage({ file, type: "hero" });
        this.toggleModal();
      },
      openFilePicker() {
        this.$refs.file.click();
      },
      toggleModal() {
        if (!this.defaultHeroImages || this.defaultHeroImages.length < 1) {
          this.loadDefaultHeroImages();
        }
        this.setState({ isHeroModalOpen: !this.isHeroModalOpen });
      },
      async uploadDefaultImage(image) {
        // Use the new setDefaultBackgroundImage action that stores S3 path reference
        // instead of re-uploading the image
        const storagePath =
          image.storagePath || this.extractStoragePath(image.src);
        this.toggleModal();

        try {
          await this.setDefaultBackgroundImage({ storagePath });
        } catch (error) {
          console.error("Failed to set default background image:", error);
        }
      },
    },
    name: "ObituaryHeroImage",
  };
</script>
